var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialImessageLtr = function SvgSocialImessageLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.024 0h55.952C90.14 0 100 9.86 100 22.024v55.952C100 90.14 90.14 100 77.976 100H22.024C9.86 100 0 90.14 0 77.976V22.024C0 9.86 9.86 0 22.024 0m2.022 26.265C30.93 20.532 40.266 17.31 50 17.31s19.07 3.22 25.953 8.954c6.884 5.733 10.75 13.51 10.75 21.617S82.838 63.767 75.954 69.5 59.734 78.454 50 78.454a43.6 43.6 0 0 1-10.384-1.266c-4.371 2.898-9.472 4.902-14.907 5.856 2.803-2.709 4.972-5.745 6.418-8.983-5.43-2.712-9.926-6.548-13.051-11.135s-4.771-9.77-4.78-15.044c0-8.108 3.867-15.884 10.75-21.617",
    clipRule: "evenodd"
  })));
};
export default SvgSocialImessageLtr;